import {useSelector} from 'react-redux';

export const useFepConfig = () => {
    const {isFepEnabled, isFepCcmMember, isMinorDependent} = useSelector(
        state => state.app
    );

    return {isFepEnabled, isFepCcmMember, isMinorDependent};
};
